import React, { useEffect, useRef } from "react";
import { cn } from "@/lib/utils";

interface InfiniteContentEditableProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const InfiniteContentEditable: React.FC<InfiniteContentEditableProps> = ({
  value,
  onChange,
  placeholder,
  className = "",
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && ref.current.textContent !== value) {
      ref.current.textContent = value;
    }
  }, [value]);

  const handleInput = () => {
    if (ref.current) {
      onChange(ref.current.textContent || "");
    }
  };

  const isEmpty = !value || value.trim() === "";

  return (
    <div
      ref={ref}
      contentEditable
      onInput={handleInput}
      role="textbox"
      aria-multiline="true"
      id={"infinite-text-area"}
      data-placeholder={placeholder}
      className={cn(
        "w-full py-2 min-h-[2rem] whitespace-pre-wrap break-words outline-none text-sm [&>*]:bg-gray-100",
        isEmpty &&
          placeholder &&
          "relative before:content-[attr(data-placeholder)] before:absolute before:text-gray-400 before:pointer-events-none before:select-none",
        className
      )}
      suppressContentEditableWarning
    />
  );
};

export default InfiniteContentEditable;
